export const MOWER_TYPES = [
  { value: "zero_turn", label: "Zero-Turn Mower" },
  { value: "riding", label: "Riding Tractor" },
  { value: "stand_on", label: "Stand-On Mower" },
  { value: "compact_tractor", label: "Compact Tractor" },
  { value: "utv", label: "UTV / Side-by-Side" },
  { value: "golf_cart", label: "Golf Cart" },
  { value: "implement", label: "Implement / Attachment" },
  { value: "other", label: "Other" },
];

export const BRANDS = [
  "Bad Boy",
  "Hustler",
  "Grasshopper",
  "Scag",
  "Worldlawn",
  "Mowhawk",
  "Stihl",
  "Other",
];

export const TIER_LABELS = {
  1: "Tier 1 — Heavy Equipment Specialists",
  2: "Tier 2 — Regional Equipment-Capable",
  3: "Tier 3 — Dry Van / Parts",
  0: "Do Not Use",
};

export const newUnit = () => ({
  id: Math.random().toString(36).slice(2),
  type: "zero_turn",
  brand: "Bad Boy",
  model: "",
  qty: 1,
  length: "",
  width: "",
  height: "",
  weight: "",
});

// Stop entries carry a stable id so React lists don't rely on array indexes.
export const newStop = (value = "") => ({
  id: Math.random().toString(36).slice(2),
  value,
  customer: "",
});
